import { render, staticRenderFns } from "./ImportButtonV3.vue?vue&type=template&id=547fef49&scoped=true"
import script from "./ImportButtonV3.vue?vue&type=script&lang=js"
export * from "./ImportButtonV3.vue?vue&type=script&lang=js"
import style0 from "./ImportButtonV3.vue?vue&type=style&index=0&id=547fef49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547fef49",
  null
  
)

export default component.exports